import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useTeamSizes() {
  const [loading, setLoading] = useState(true);
  const [teamSizes, setTeamSizes] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.team_sizes.index)
      .then((response) => {
        setTeamSizes(response.data.data);
        setLoading(false);
      });
  }, []);

  return { loading, teamSizes };
}
